// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file cos/briefing.proto (package lvdr.v2.cos, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AiMark } from "../common/aimark_pb";
import { file_common_aimark } from "../common/aimark_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cos/briefing.proto.
 */
export const file_cos_briefing: GenFile = /*@__PURE__*/
  fileDesc("ChJjb3MvYnJpZWZpbmcucHJvdG8SC2x2ZHIudjIuY29zIkQKF1ByZXBhcmVCcmllZmluZ3NSZXF1ZXN0EhMKC3N1YmplY3RfaWRzGAEgAygJEhQKDHdvcmtzcGFjZV9pZBgCIAEoCSJGChhQcmVwYXJlQnJpZWZpbmdzUmVzcG9uc2USKgoGc3RhdGVzGAEgAygLMhoubHZkci52Mi5jb3MuQnJpZWZpbmdTdGF0ZSKUAQoNQnJpZWZpbmdTdGF0ZRISCgpzdWJqZWN0X2lkGAEgASgJEg4KBnN0YXR1cxgCIAEoCRIOCgZyZWFzb24YAyABKAkSEQoJZGFpbHlfbWF4GAQgASgFEhcKD3JldHJ5X2FmdGVyX3NlYxgFIAEoBRIUCgxwZXJfdmlld19tYXgYBiABKAUSDQoFc3RhbGUYByABKAgiPgoSR2V0QnJpZWZpbmdSZXF1ZXN0EhIKCnN1YmplY3RfaWQYASABKAkSFAoMd29ya3NwYWNlX2lkGAIgASgJIj4KE0dldEJyaWVmaW5nUmVzcG9uc2USJwoIYnJpZWZpbmcYASABKAsyFS5sdmRyLnYyLmNvcy5CcmllZmluZyLqAgoIQnJpZWZpbmcSEgoKc3ViamVjdF9pZBgBIAEoCRIOCgZzdGF0dXMYAiABKAkSDgoGcmVhc29uGAMgASgJEg0KBWRlcHRoGAQgASgJEhAKCGhlYWRsaW5lGAUgASgJEjAKCXNlbnRlbmNlcxgGIAMoCzIdLmx2ZHIudjIuY29zLkJyaWVmaW5nU2VudGVuY2USLAoHc291cmNlcxgHIAMoCzIbLmx2ZHIudjIuY29zLkJyaWVmaW5nU291cmNlEhcKD2dlbmVyYXRlZF9hdF9tcxgIIAEoAxInCgdhaV9tYXJrGAkgASgLMhYubHZkci52Mi5jb21tb24uQWlNYXJrEhEKCWRhaWx5X21heBgKIAEoBRIXCg9yZXRyeV9hZnRlcl9zZWMYCyABKAUSDQoFc3RhbGUYDCABKAgSFAoMcGVyX3ZpZXdfbWF4GA0gASgFEhYKDnJldGVudGlvbl9kYXlzGA4gASgFIjQKEEJyaWVmaW5nU2VudGVuY2USDAoEdGV4dBgBIAEoCRISCgpzb3VyY2VfaWR4GAIgAygFIlAKDkJyaWVmaW5nU291cmNlEgwKBGtpbmQYASABKAkSCgoCaWQYAiABKAkSDQoFdGl0bGUYAyABKAkSFQoNdXBkYXRlZF9hdF9tcxgEIAEoAyJBChVPcGVuZWRCcmllZmluZ1JlcXVlc3QSEgoKc3ViamVjdF9pZBgBIAEoCRIUCgx3b3Jrc3BhY2VfaWQYAiABKAkiKgoWT3BlbmVkQnJpZWZpbmdSZXNwb25zZRIQCghyZWNvcmRlZBgBIAEoCCI6ChRCcmllZmluZ1VwZGF0ZWRFdmVudBISCgpzdWJqZWN0X2lkGAEgASgJEg4KBnN0YXR1cxgCIAEoCUIkWiJnaXRodWIuY29tL2d2czQyL2x2ZHIvcHJvdG8vdjIvY29zYgZwcm90bzM", [file_common_aimark]);

/**
 * @generated from message lvdr.v2.cos.PrepareBriefingsRequest
 */
export type PrepareBriefingsRequest = Message<"lvdr.v2.cos.PrepareBriefingsRequest"> & {
  /**
   * @generated from field: repeated string subject_ids = 1;
   */
  subjectIds: string[];

  /**
   * "" = Private; anything else answers scope_unsupported
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.cos.PrepareBriefingsRequest.
 * Use `create(PrepareBriefingsRequestSchema)` to create a new message.
 */
export const PrepareBriefingsRequestSchema: GenMessage<PrepareBriefingsRequest> = /*@__PURE__*/
  messageDesc(file_cos_briefing, 0);

/**
 * @generated from message lvdr.v2.cos.PrepareBriefingsResponse
 */
export type PrepareBriefingsResponse = Message<"lvdr.v2.cos.PrepareBriefingsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.cos.BriefingState states = 1;
   */
  states: BriefingState[];
};

/**
 * Describes the message lvdr.v2.cos.PrepareBriefingsResponse.
 * Use `create(PrepareBriefingsResponseSchema)` to create a new message.
 */
export const PrepareBriefingsResponseSchema: GenMessage<PrepareBriefingsResponse> = /*@__PURE__*/
  messageDesc(file_cos_briefing, 1);

/**
 * status: missing | queued | generating | ready | failed | deferred | capped | no_model
 * reason: "" | disabled | subject_unknown | scope_unsupported | per_view_cap | daily_cap |
 *         limiter_unavailable | busy | source_unavailable | ungrounded | model_unavailable |
 *         floor_unavailable | confidential | sovereign
 *
 * @generated from message lvdr.v2.cos.BriefingState
 */
export type BriefingState = Message<"lvdr.v2.cos.BriefingState"> & {
  /**
   * @generated from field: string subject_id = 1;
   */
  subjectId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * set with daily_cap
   *
   * @generated from field: int32 daily_max = 4;
   */
  dailyMax: number;

  /**
   * set with daily_cap
   *
   * @generated from field: int32 retry_after_sec = 5;
   */
  retryAfterSec: number;

  /**
   * set with per_view_cap
   *
   * @generated from field: int32 per_view_max = 6;
   */
  perViewMax: number;

  /**
   * @generated from field: bool stale = 7;
   */
  stale: boolean;
};

/**
 * Describes the message lvdr.v2.cos.BriefingState.
 * Use `create(BriefingStateSchema)` to create a new message.
 */
export const BriefingStateSchema: GenMessage<BriefingState> = /*@__PURE__*/
  messageDesc(file_cos_briefing, 2);

/**
 * @generated from message lvdr.v2.cos.GetBriefingRequest
 */
export type GetBriefingRequest = Message<"lvdr.v2.cos.GetBriefingRequest"> & {
  /**
   * @generated from field: string subject_id = 1;
   */
  subjectId: string;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.cos.GetBriefingRequest.
 * Use `create(GetBriefingRequestSchema)` to create a new message.
 */
export const GetBriefingRequestSchema: GenMessage<GetBriefingRequest> = /*@__PURE__*/
  messageDesc(file_cos_briefing, 3);

/**
 * @generated from message lvdr.v2.cos.GetBriefingResponse
 */
export type GetBriefingResponse = Message<"lvdr.v2.cos.GetBriefingResponse"> & {
  /**
   * @generated from field: lvdr.v2.cos.Briefing briefing = 1;
   */
  briefing?: Briefing | undefined;
};

/**
 * Describes the message lvdr.v2.cos.GetBriefingResponse.
 * Use `create(GetBriefingResponseSchema)` to create a new message.
 */
export const GetBriefingResponseSchema: GenMessage<GetBriefingResponse> = /*@__PURE__*/
  messageDesc(file_cos_briefing, 4);

/**
 * @generated from message lvdr.v2.cos.Briefing
 */
export type Briefing = Message<"lvdr.v2.cos.Briefing"> & {
  /**
   * @generated from field: string subject_id = 1;
   */
  subjectId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * full | delta
   *
   * @generated from field: string depth = 4;
   */
  depth: string;

  /**
   * @generated from field: string headline = 5;
   */
  headline: string;

  /**
   * @generated from field: repeated lvdr.v2.cos.BriefingSentence sentences = 6;
   */
  sentences: BriefingSentence[];

  /**
   * @generated from field: repeated lvdr.v2.cos.BriefingSource sources = 7;
   */
  sources: BriefingSource[];

  /**
   * 0 = none
   *
   * @generated from field: int64 generated_at_ms = 8;
   */
  generatedAtMs: bigint;

  /**
   * set whenever text is served
   *
   * @generated from field: lvdr.v2.common.AiMark ai_mark = 9;
   */
  aiMark?: AiMark | undefined;

  /**
   * @generated from field: int32 daily_max = 10;
   */
  dailyMax: number;

  /**
   * @generated from field: int32 retry_after_sec = 11;
   */
  retryAfterSec: number;

  /**
   * old text served while an update runs
   *
   * @generated from field: bool stale = 12;
   */
  stale: boolean;

  /**
   * @generated from field: int32 per_view_max = 13;
   */
  perViewMax: number;

  /**
   * footer copy; server-reported
   *
   * @generated from field: int32 retention_days = 14;
   */
  retentionDays: number;
};

/**
 * Describes the message lvdr.v2.cos.Briefing.
 * Use `create(BriefingSchema)` to create a new message.
 */
export const BriefingSchema: GenMessage<Briefing> = /*@__PURE__*/
  messageDesc(file_cos_briefing, 5);

/**
 * @generated from message lvdr.v2.cos.BriefingSentence
 */
export type BriefingSentence = Message<"lvdr.v2.cos.BriefingSentence"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * 0-based into Briefing.sources
   *
   * @generated from field: repeated int32 source_idx = 2;
   */
  sourceIdx: number[];
};

/**
 * Describes the message lvdr.v2.cos.BriefingSentence.
 * Use `create(BriefingSentenceSchema)` to create a new message.
 */
export const BriefingSentenceSchema: GenMessage<BriefingSentence> = /*@__PURE__*/
  messageDesc(file_cos_briefing, 6);

/**
 * @generated from message lvdr.v2.cos.BriefingSource
 */
export type BriefingSource = Message<"lvdr.v2.cos.BriefingSource"> & {
  /**
   * task | note | research | conversation
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: int64 updated_at_ms = 4;
   */
  updatedAtMs: bigint;
};

/**
 * Describes the message lvdr.v2.cos.BriefingSource.
 * Use `create(BriefingSourceSchema)` to create a new message.
 */
export const BriefingSourceSchema: GenMessage<BriefingSource> = /*@__PURE__*/
  messageDesc(file_cos_briefing, 7);

/**
 * @generated from message lvdr.v2.cos.OpenedBriefingRequest
 */
export type OpenedBriefingRequest = Message<"lvdr.v2.cos.OpenedBriefingRequest"> & {
  /**
   * @generated from field: string subject_id = 1;
   */
  subjectId: string;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.cos.OpenedBriefingRequest.
 * Use `create(OpenedBriefingRequestSchema)` to create a new message.
 */
export const OpenedBriefingRequestSchema: GenMessage<OpenedBriefingRequest> = /*@__PURE__*/
  messageDesc(file_cos_briefing, 8);

/**
 * @generated from message lvdr.v2.cos.OpenedBriefingResponse
 */
export type OpenedBriefingResponse = Message<"lvdr.v2.cos.OpenedBriefingResponse"> & {
  /**
   * @generated from field: bool recorded = 1;
   */
  recorded: boolean;
};

/**
 * Describes the message lvdr.v2.cos.OpenedBriefingResponse.
 * Use `create(OpenedBriefingResponseSchema)` to create a new message.
 */
export const OpenedBriefingResponseSchema: GenMessage<OpenedBriefingResponse> = /*@__PURE__*/
  messageDesc(file_cos_briefing, 9);

/**
 * Pushed when a job ends. Carries no text; the client calls GetBriefing.
 *
 * @generated from message lvdr.v2.cos.BriefingUpdatedEvent
 */
export type BriefingUpdatedEvent = Message<"lvdr.v2.cos.BriefingUpdatedEvent"> & {
  /**
   * @generated from field: string subject_id = 1;
   */
  subjectId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.cos.BriefingUpdatedEvent.
 * Use `create(BriefingUpdatedEventSchema)` to create a new message.
 */
export const BriefingUpdatedEventSchema: GenMessage<BriefingUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_cos_briefing, 10);

